import React, { useEffect, useState } from 'react'
import { BaseLayout } from 'src/layouts'
import { useAppIntl } from 'src/i18n'
import styles from './styles.module.scss'
import { Header } from './components/Header'
import { Filter } from './components/Filter'
import { List } from './components/List'
import { useGlossary } from 'src/state'
import { intl } from 'src/i18n'
import { WEBSITE } from 'src/consts'
import { useDispatch } from 'react-redux'

const formatGlossary = data => {
  const itemParse = {}

  if (!!data) {
    data.forEach(item => {
      const index = item.attributes.title

      itemParse[index] = item.attributes.glossaries.data.map(glossarie => ({
        title: glossarie.attributes.title,
        shortPreview: glossarie.attributes.shortPreview,
        content: glossarie.attributes.content,
        slug: glossarie.attributes.slug,
      }))
    })
  }

  return { data: itemParse }
}
export const Glossary = () => {
  const glossaryData = formatGlossary(useGlossary().data)
  const keys = Object.keys(glossaryData.data)
  const [itemActive, setItemActive] = useState('')

  const [dataFilter, setDataFilter] = useState(glossaryData.data)
  const [search, setSearch] = useState('')
  const dispatch = useDispatch()

  useEffect(() => {
    if (search) {
      const dataFilter = keys.reduce((acc, key) => {
        const data = glossaryData.data[key].filter(item => {
          return item.title.toLowerCase().includes(search.toLowerCase())
        })
        return { ...acc, [key]: data }
      }, {})

      setDataFilter(
        Object.entries(dataFilter)
          .filter(([key, value]) => value)
          .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
      )
    } else {
      setDataFilter(glossaryData.data)
    }
  }, [search])

  useEffect(() => {
    if (itemActive === '') {
      setDataFilter(glossaryData.data)
    } else {
      const newData = glossaryData.data[itemActive]
      setDataFilter({ [itemActive]: newData })
      setSearch('')
    }
  }, [itemActive])

  const title = intl.t('glossary.seo.title')
  const description = intl.t('glossary.seo.description')
  const uri = `glossary`

  const glossarySchema = {
    '@type': 'ItemList',
    name: 'Crypto Glossary',
    description:
      'Navigate the crypto world with ease using COIN360s glossary. Understand essential terms and concepts from the world of blockchain and digital assets.',
    itemListElement: [],
  }

  Object.keys(glossaryData.data).forEach((key, index) => {
    glossaryData.data[key].forEach(item => {
      glossarySchema.itemListElement.push({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Thing',
          name: item.title,
          description: item.shortPreview,
          url: `${WEBSITE}/glossary/${item.slug}`,
        },
      })
      index++
    })
  })

  return (
    <BaseLayout
      scrollInContent
      seo={{
        title: 'Crypto Glossary: Key Terms & Definitions',
        description:
          'Navigate the crypto world with ease using COIN360s glossary. Understand essential terms and concepts from the world of blockchain and digital assets.',
        canonical: `${WEBSITE}/${uri}`,
        jsonLd: glossarySchema as any,
      }}
    >
      <div className={styles.container}>
        <Header />
        <Filter
          keys={keys}
          itemActive={itemActive}
          setItemActive={setItemActive}
          search={search}
          setSearch={setSearch}
        />
        <div className={styles.mainContent}>
          <List data={dataFilter} />
        </div>
      </div>
    </BaseLayout>
  )
}
